import React, { useState, useEffect } from 'react';
import axios from 'axios';

const durumRenk = { bekliyor: 'badge-bekliyor', onaylandi: 'badge-tamamlandi', reddedildi: 'badge-hata' };
const durumEtiket = { bekliyor: 'Bekliyor', onaylandi: 'Onaylandı', reddedildi: 'Reddedildi' };

const IzinTalepPage = () => {
  const [izinler, setIzinler] = useState([]);
  const [izinTurleri, setIzinTurleri] = useState([]);
  const [yeniPanel, setYeniPanel] = useState(false);
  const [form, setForm] = useState({ izin_turu: '', baslangic_tarihi: '', bitis_tarihi: '', aciklama: '' });
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = () => {
    axios.get('/api/personel/izinler').then(r => setIzinler(r.data)).catch(console.error);
    axios.get('/api/admin/dinamik-listeler/izin_turleri').then(r => setIzinTurleri(r.data)).catch(console.error);
  };
  useEffect(() => { yukle(); }, []);

  const gunHesapla = () => {
    if (!form.baslangic_tarihi || !form.bitis_tarihi) return 0;
    const bas = new Date(form.baslangic_tarihi);
    const bit = new Date(form.bitis_tarihi);
    return Math.max(0, Math.ceil((bit - bas) / (1000 * 60 * 60 * 24)) + 1);
  };

  const handleGonder = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/personel/izinler', form);
      setSonuc({ tip: 'basari', mesaj: 'İzin talebiniz oluşturuldu.' });
      setForm({ izin_turu: '', baslangic_tarihi: '', bitis_tarihi: '', aciklama: '' });
      setYeniPanel(false);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleIptal = async (id) => {
    if (!window.confirm('Bu talebi iptal etmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete('/api/personel/izinler/' + id);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'İptal edilemedi.' }); }
  };

  const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>İzin Taleplerim</h2>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>İzin taleplerinizi oluşturun ve takip edin.</p>
        </div>
        <button className="btn btn-primary" onClick={() => setYeniPanel(!yeniPanel)}>+ Yeni İzin Talebi</button>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {/* Yeni Talep Formu */}
      {yeniPanel && (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header"><h2>Yeni İzin Talebi</h2></div>
          <form onSubmit={handleGonder}>
            <div className="form-grid">
              <div className="form-group full">
                <label>İzin Türü *</label>
                <select value={form.izin_turu} onChange={e => setForm({ ...form, izin_turu: e.target.value })} required>
                  <option value="">-- Seçin --</option>
                  {izinTurleri.map(t => <option key={t.deger} value={t.deger}>{t.etiket}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Başlangıç Tarihi *</label>
                <input type="date" value={form.baslangic_tarihi} onChange={e => setForm({ ...form, baslangic_tarihi: e.target.value })} required />
              </div>
              <div className="form-group">
                <label>Bitiş Tarihi *</label>
                <input type="date" value={form.bitis_tarihi} min={form.baslangic_tarihi} onChange={e => setForm({ ...form, bitis_tarihi: e.target.value })} required />
              </div>
              {gunHesapla() > 0 && (
                <div className="form-group full">
                  <div style={{ background: 'var(--mavi-acik)', borderRadius: 'var(--radius-sm)', padding: '0.6rem 1rem', fontSize: '14px', color: 'var(--mavi)', fontWeight: '500' }}>
                    Toplam: {gunHesapla()} gün
                  </div>
                </div>
              )}
              <div className="form-group full">
                <label>Açıklama</label>
                <textarea value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} placeholder="İsteğe bağlı açıklama..." />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Gönderiliyor...' : 'Talebi Gönder'}</button>
              <button type="button" className="btn btn-secondary" onClick={() => setYeniPanel(false)}>İptal</button>
            </div>
          </form>
        </div>
      )}

      {/* İzin Listesi */}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {izinler.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Henüz izin talebiniz bulunmuyor.</div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead>
                <tr><th>İzin Türü</th><th>Başlangıç</th><th>Bitiş</th><th>Gün</th><th>Durum</th><th>Onay Notu</th><th></th></tr>
              </thead>
              <tbody>
                {izinler.map(i => (
                  <tr key={i.id}>
                    <td style={{ fontWeight: '500' }}>{i.izin_turu}</td>
                    <td style={{ fontSize: '13px' }}>{fmt(i.baslangic_tarihi)}</td>
                    <td style={{ fontSize: '13px' }}>{fmt(i.bitis_tarihi)}</td>
                    <td style={{ fontSize: '13px' }}>{i.gun_sayisi}</td>
                    <td><span className={'badge ' + (durumRenk[i.durum] || 'badge-bekliyor')}>{durumEtiket[i.durum] || i.durum}</span></td>
                    <td style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{i.onay_notu || '—'}</td>
                    <td>
                      {i.durum === 'bekliyor' && (
                        <button className="btn btn-danger btn-sm" onClick={() => handleIptal(i.id)}>İptal</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
export default IzinTalepPage;
